import * as styles from "./ComboboxItem.css";

import { clsx } from "clsx";
import { type JSX } from "react";

import { Combobox as BaseCombobox } from "@base-ui/react/combobox";
import { Icon } from "@frontend/components/atoms/Icon";

import type { ComboboxItemProps } from "./Combobox.types";

export function ComboboxItem({
  className,
  children,
  description,
  status,
  ref,
  ...props
}: ComboboxItemProps): JSX.Element {
  return (
    <BaseCombobox.Item
      data-slot="combobox-item"
      className={clsx(styles.item, className)}
      ref={ref}
      {...props}
    >
      <span className={styles.itemContent}>
        <span className={styles.itemText}>
          {status ? <span className={styles.itemStatus[status]} /> : null}
          {children}
        </span>
        {description ? (
          <span className={styles.itemDescription}>{description}</span>
        ) : null}
      </span>
      <BaseCombobox.ItemIndicator className={styles.itemIndicator}>
        <Icon name="Check" size="sm" />
      </BaseCombobox.ItemIndicator>
    </BaseCombobox.Item>
  );
}
